module.exports = __webpack_public_path__ + "40917db8dd65f7dd757acdbdef7c833e.svg";